import React from "react"
import { DateTime } from "luxon"
import { Clock } from "lucide-mui"
import i18n from "@/i18n"

interface WorkingHourLabelProps {
  kind: string
  weekday?: number
  startTime: string
  endTime: string
  startDate?: string | null
  endDate?: string | null
  closed?: boolean
}

const WorkingHourLabel = ({ kind, weekday, startTime, endTime, startDate, endDate, closed }: WorkingHourLabelProps) => {
  const DAYS = [
    i18n.t("app.days.sunday"),
    i18n.t("app.days.monday"),
    i18n.t("app.days.tuesday"),
    i18n.t("app.days.wednesday"),
    i18n.t("app.days.thursday"),
    i18n.t("app.days.friday"),
    i18n.t("app.days.saturday"),
  ]

  const isRegular = kind === "regular"
  const bgColor = isRegular ? "bg-gray-100" : "bg-yellow-100"
  const iconColor = isRegular ? "text-gray-600" : "text-yellow-700"

  const formatDate = (date: string) => {
    return DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED)
  }

  if (!kind) {
    return <span className="text-sm">{i18n.t("app.common.none")}</span>
  }

  return (
    <div className={`text-sm ${bgColor} px-2 py-1 rounded inline-flex flex-row items-center gap-2`}>
      <Clock className={`${iconColor} w-4 h-4`} />
      {isRegular && weekday != null && <span className="font-semibold">{DAYS[weekday]}</span>}
      {!isRegular && startDate && (
        <span className="font-semibold">
          {formatDate(startDate)}
          {endDate && ` - ${formatDate(endDate)}`}
        </span>
      )}
      <span>
        {startTime} - {endTime}
      </span>
      {closed && <span className="text-gray-500">({i18n.t("app.common.closed")})</span>}
    </div>
  )
}

export default WorkingHourLabel
